module.exports = __webpack_public_path__ + "static/media/sell_resend_invoice_4.c0d79bb5.jpg";